module.exports = __webpack_public_path__ + "static/media/bicycle_white.c362dde9.svg";